import { Component, computed, inject, OnInit } from '@angular/core';
import { FADEIN_OUT_ANIMATION } from '../../../shared/constants/animations';
import { RouterLink } from "@angular/router";
import { SignalsStoreService } from '../../../shared/signals-store.service';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
    // animations: FADEIN_OUT_ANIMATION,
    selector: 'app-rewards-program',
    imports: [
        RouterLink
    ],
    templateUrl: './rewards-program.component.html',
    styleUrl: './rewards-program.component.scss'
})
export class RewardsProgramComponent implements OnInit {
  private signalsStoreService = inject(SignalsStoreService);
  private meta = inject(Meta);
  private title = inject(Title)

  membershipRouterLink = computed(() => {
    const hasSession = this.signalsStoreService.hasSession();
    return hasSession ? '/settings/billing/membership' : ''    
  })

  ngOnInit(): void {
    this.setUpSEOTags()
  }

  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/how-it-works/rewards-program'
    const component = 'Roots Rewards'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }
}
